import React from 'react'
import { Stack, Text, Header, Button, Loader } from '@crossfit/ui'
import { Teammate } from 'types'
import Modal from 'components/Modal'
import { useRemoveTeammate } from './hooks'
import { useSelector } from 'react-redux'
import { getAffiliate } from 'store/selectors'

type Props = {
  onClose: () => void
  teammate: Teammate
}

function RemoveTeammate({ onClose, teammate }: Props) {
  const { firstName, lastName } = teammate
  const name = firstName + '' + lastName
  const affiliate = useSelector(getAffiliate)
  const { onSubmit, isSubmitting } = useRemoveTeammate({ onClose, teammate })

  return (
    <Modal
      onClose={onClose}
      header={
        <Header size='small' as='h3'>
          Remove {name}?
        </Header>
      }
    >
      {isSubmitting ? (
        <Loader />
      ) : (
        <form onSubmit={onSubmit}>
          <Text mb={8}>
            <strong>{name}</strong> will no longer have access to the{' '}
            {affiliate?.name} team.
          </Text>
          <Stack
            direction='horizontal'
            style={{ justifyContent: 'flex-end' }}
            spacing={4}
          >
            <Button type='button' onClick={onClose} variant='secondary'>
              Cancel
            </Button>
            <Button type='submit' variant='destructive'>
              Remove Teammate
            </Button>
          </Stack>
        </form>
      )}
    </Modal>
  )
}

export default RemoveTeammate
